import { useEffect, useState } from 'react';
import WhoDunIt2026 from '../classes/WhoDunIt2026';

const readState = () => ({
  isEnabled: WhoDunIt2026.isEnabled(),
  progress: WhoDunIt2026.getProgress(),
});

export const useWhodunit2026State = () => {
  const [state, setState] = useState(readState);

  useEffect(() => {
    const handleChange = () => setState(readState());
    window.addEventListener('storage', handleChange);
    window.addEventListener(WhoDunIt2026.CHANGE_EVENT, handleChange);
    return () => {
      window.removeEventListener('storage', handleChange);
      window.removeEventListener(WhoDunIt2026.CHANGE_EVENT, handleChange);
    };
  }, []);

  return state;
};
